import React, { useState } from "react";
import { FaRegCircleXmark } from "react-icons/fa6";
import { useDispatch } from "react-redux";
import { deleteQuestionCategoryWithAnswer } from "../../store/slices/apiQuestionCategorySlice";
import EditModalQuestionWithCategory from "../Modals/EditModal/EditModalQuestionWithCategory";
import { FaPencilAlt } from "react-icons/fa";

const TableItemsQuestionWithCategoryResponsive = ({
  dataQuestionCategory,
  baseUrl,
}) => {
  const dispatch = useDispatch();
  const [item, setItem] = useState();
  const [open, setOpen] = useState(false);
  const handleDeleteItem = (id) => {
    dispatch(deleteQuestionCategoryWithAnswer(id));
  };
  const onClose = () => {
    setOpen(!open);
  };

  return (
    <>
      {open && <EditModalQuestionWithCategory item={item} onClose={onClose} />}
      <div className="block sm:hidden space-y-4">
        {dataQuestionCategory?.data?.map((item) => (
          <div
            key={item.questionCategory_id}
            className="bg-white shadow rounded-lg p-4 text-sm space-y-2"
          >
            <div>
              <strong>Pyetja:</strong>
              <div className="flex flex-col mt-1 text-gray-800 space-y-1">
                {item.question_text
                  .split(" ")
                  .reduce((acc, word, idx) => {
                    const lineIdx = Math.floor(idx / 4);
                    if (!acc[lineIdx]) acc[lineIdx] = [];
                    acc[lineIdx].push(word);
                    return acc;
                  }, [])
                  .map((lineWords, index) => (
                    <span key={index}>{lineWords.join(" ")}</span>
                  ))}
              </div>
            </div>

            <p>
              <strong>Kategoria:</strong> {item.category_name}
            </p>
            <p>
              <strong>Emri i Pyetjes:</strong> {item.category_question_name}
            </p>
            <p>
              <strong>Ikona:</strong>{" "}
              <a
                href={`${baseUrl}/${item.question_icon}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={`${baseUrl}/${item.question_icon}`}
                  alt="Ikona"
                  className="w-14 h-14 object-cover mt-2"
                />
              </a>
            </p>
            <p>
              <strong>Pikët:</strong> {item.question_score}
            </p>
            <div className="flex gap-2 pt-2">
              <button
                onClick={() => {
                  setOpen(!open);
                  setItem(item);
                }}
              >
                <FaPencilAlt
                  style={{ width: 20, height: 20, color: "#21C621" }}
                />
              </button>
              <button
                className="text-danger"
                onClick={() => handleDeleteItem(item.questionCategory_id)}
              >
                <FaRegCircleXmark style={{ width: 20, height: 20 }} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default TableItemsQuestionWithCategoryResponsive;
